
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import ManagementFrame from '@/components/ui/managementFrame/index.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import {
  Form, Input, Select, Pagination, Button, Upload, Table,
} from 'ant-design-vue';
import asynButtonVue from '@/components/asynButton.vue';

// import myButton from '@/components/Button.vue';
import myFormModal from '@/components/myFormModal.vue';
import myModal from '@/components/Modal.vue';
import controllerModuleFun from './js/controllerModule';
import teacherModuleFun from './js/teacherModule';
import classModuleFun from './js/classModule';
import classMemberFun from './js/classMemberModule';
import '@/assets/icons/back.svg';
import '@/assets/icons/plus.svg';
import '@/assets/icons/search.svg';

export default defineComponent({
  name: 'user-manager',
  components: {
    ManagementFrame,
    SvgIcon,
    aFormItem: Form.Item,
    aInput: Input,
    aSelect: Select,
    aSelectOption: Select.Option,
    aPagination: Pagination,
    aButton: asynButtonVue,
    aUpload: Upload,
    aTable: Table,
    myFormModal,
    // myButton,
    myModal,
  },
  props: {},
  setup() {
    const router = useRouter();

    const classModule = classModuleFun();
    const teacherModule = teacherModuleFun();
    const classMemberModule = classMemberFun();
    const controllerModule = controllerModuleFun(router, classModule.handlePlusClick, teacherModule.handlePlusClick, teacherModule.teacherModule, classMemberModule.handlePlusClick, classModule.classModule);

    return {
      controllerModule,
      teacherModule,
      classMemberModule,
      classModule,
    };
  },
});
